var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"},on:{"click":_vm.handleClick}},[_c('use',{attrs:{"xlink:href":'#icon-'+_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }